/**
 * Normalize date string by converting to ISO format.
 * Handles Supabase format ("2025-08-27 12:30:02+00") and ISO format passthrough.
 */
export function normalizeDate(dateString: string | null | undefined): string | null | undefined {
  if (!dateString) return dateString;

  // If it's already in ISO format, return as-is
  if (dateString.includes('T')) {
    return dateString;
  }

  // Handle Supabase format: "2025-08-27 12:30:02+00"
  if (dateString.includes(' ')) {
    const datePart = dateString.split(' ')[0];
    const timePart = dateString.split(' ')[1];
    const cleanTimePart = timePart.replace(/[+-]\d{2}$/, '');
    return `${datePart}T${cleanTimePart}Z`;
  }

  // Return as-is for other formats
  return dateString;
}
